import React from 'react'
import PropTypes from 'prop-types'
import styles from './TableSlatePlugin.scss'

const TableNode = ({ attributes, children, node }) => {
  const align = (node && node.get('data') && node.get('data').get('align')) || 'left'
  const width = (node && node.get('data') && node.get('data').get('width')) || 'auto'
  return <td id={'TableNode'} style={{ textAlign: align, width: width }} className={styles.TableCell} {...attributes}>
    {children}
  </td>
}

TableNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node,
  node: PropTypes.object
}

export default TableNode



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/TableCell.js